﻿import type { RebindDataSourceTypeControl, RebindAsyncTypeControl } from '../types/utils/rebind-data-source';

function rebindDataSource(control: RebindDataSourceTypeControl) {
    if (!control) {
        console.warn('Rebinding failed, control not found');
        return;
    }
    if (control instanceof kendo.ui.Gantt) {
        control.dataSource.read();
        control.dependencies.read();
        return;
    }

    if (control instanceof kendo.ui.Scheduler) {
        control.resources.forEach((resource: kendo.ui.SchedulerResource) => resource.dataSource.read());
        control.dataSource.read();
        return;
    }

    control.dataSource.read();
}

function rebindAsync(instance: RebindAsyncTypeControl) {
    return new Promise((resolve) => {
        instance.dataSource.read().done(resolve);
    });
}

window.rebindAsync = rebindAsync;
window.rebindDataSource = rebindDataSource;